<template>
  <header>
    <div class="container-fluid top-menu">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-sm-8 header-logo">
            <router-link to="/" class="logo-text d-none d-sm-block">
              <img class="site-logo" src="~@/assets/images/logo_dkf.png" alt="Friday Financial Logo">
            </router-link>
            <router-link to="/" class="logo-text logo-text-mobile d-sm-none">
              <img class="site-logo" src="~@/assets/images/logo_dkf.png" alt="Friday Financial Logo">
            </router-link>
          </div>
          <MobileMenu></MobileMenu>
          <div class="col-lg-8 navigation d-flex align-items-center">
            <ul class="header-nav-items menu">
              <li>
                <div>
                  <router-link class="header-nav-link" to="/our-story/">Our story</router-link>
                </div>
              </li>
              <li>
                <router-link class="header-nav-link" to="/mortgage-advice/">Mortgage Advice</router-link>
              </li>
              <li>
                <router-link class="header-nav-link" to="/protection/">Protection</router-link>
              </li>
              <li>
                <router-link class="header-nav-link" to="/contact-us/">Contact Us</router-link>
              </li>
              <li class="orangebackground">
                <a href="tel:01502 389559" class="header-nav-link header-tel">
                  <strong>01502 389559</strong>
                </a>
              </li>
              <li>
                <div>
                  <a href="https://www.google.com/search?q=friday+financial+services+&source=hp&ei=loS4YYGqHMGmaO6qvvAP&iflsig=ALs-wAMAAAAAYbiSpvjSRos7WZgrLGM9HNutAbleaig6&ved=0ahUKEwiBzYOpnOP0AhVBExoKHW6VD_4Q4dUDCAo&uact=5&oq=friday+financial+services+&gs_lcp=Cgdnd3Mtd2l6EAMyCwguEIAEEMcBEK8BOgsIABCABBCxAxCDAToOCC4QgAQQsQMQxwEQowI6DgguEIAEELEDEMcBENEDOgUILhCABDoICAAQgAQQsQM6CAguELEDEIMBOggIABCxAxCDAToOCC4QgAQQsQMQxwEQrwE6BQgAEIAEOggILhCABBCxAzoICAAQgAQQyQM6BggAEBYQHjoJCAAQyQMQFhAeUABY_R9g1yBoAHAAeACAAc0BiAHOIpIBBjAuMjkuMZgBAKABAQ&sclient=gws-wiz#lrd=0x47da1bf8b555ca21:0x947cf20227ed3bbe,1,,," target="_blank" class="d-flex align-items-center"><img src="~@/assets/images/google_g.png" alt="Google Reviews" class="site-logo"></a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

  import MobileMenu from "@/components/partials/MobileMenu";

  export default {
    name: "main-header",
    components: {
      MobileMenu,
    }
  };
</script>

<style scoped lang="scss">
.site-logo {
  max-height: 85px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainHeader.vue